import { CapoPlugin } from "/app/node_modules/.pnpm/@unhead+vue@1.9.16_vue@3.4.37/node_modules/@unhead/vue/dist/index.mjs";
export default import.meta.server ? [CapoPlugin({ track: true })] : [];